// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: true,
  apiUrl: 'https://ecommsvcwebservice.vw.co.za/api',
  brand: 'audi',
  mockData: false,
  mockSAPData: false,
  sapApiUrl: 'https://ecommsapservice.vw.co.za/api/sap',
  sapApiKey: '841007c5283a09d2fdb25fd8c0dd30ade5e56c5579a5fb2e1ff055779b860d9b',
  paymentUrl: 'https://secure.payu.co.za/rpp.do',
  googleAnalyticsId: 'GTM-NMPBCFV',
  captchaKey_audi: '67a78072-041c-4587-97c9-5e06e5fcea01',
  captchaKey_vwsa: 'e6054795-5bac-4685-8148-14eeac3aac3e',
  googleTagManagerId: 'GTM-M3F7GZJ',
  templateDownload: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 *   
  production: false,
  apiUrl: 'http://localhost:7000/api',
  brand: 'vwsa',
  mockData: false,
  mockSAPData: false,
  sapApiUrl: 'http://localhost:5124/api/sap',
  sapApiKey: '841007c5283a09d2fdb25fd8c0dd30ade5e56c5579a5fb2e1ff055779b860d9b',
  paymentUrl: 'https://staging.payu.co.za/rpp.do',
  googleAnalyticsId: 'G-E2Z75T5K45',
  captchaKey_audi: '55f0de48-8788-47f8-b6c1-7661e1508243',
  captchaKey_vwsa: '55f0de48-8788-47f8-b6c1-7661e1508243',
  googleTagManagerId:'GTM-M3F7GZJ',
  templateDownload: false,
 * 
 * 
 * 
 * 
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
